import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../actions/index.types';
import * as req from '../../../../axios/request/SocietyPortal/NoticeReqs/NoticeReqs';

function* getNoticesList(action) {
    try {
        const result = yield call(req.getNoticesListReq, action);
        if (result?.success === true) {
            yield put({
                type: types.SOCIETY_GET_NOTICES_LIST_SUCCESS,
                payload: { rows: result.data, pagination: result.meta?.pagination },
            });
        } else {
            yield put({ type: types.SOCIETY_GET_NOTICES_LIST_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_GET_NOTICES_LIST_FAILURE, message: e?.message });
    }
}

function* getNoticeBoard(action) {
    try {
        const result = yield call(req.getNoticeBoardReq, action);
        if (result?.success === true) {
            yield put({
                type: types.SOCIETY_GET_NOTICE_BOARD_SUCCESS,
                payload: { rows: result.data, pagination: result.meta?.pagination },
            });
        } else {
            yield put({ type: types.SOCIETY_GET_NOTICE_BOARD_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_GET_NOTICE_BOARD_FAILURE, message: e?.message });
    }
}

function* getNoticeDetails(action) {
    try {
        const result = yield call(req.getNoticeDetailsReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_GET_NOTICE_DETAILS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_NOTICE_DETAILS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_GET_NOTICE_DETAILS_FAILURE, message: e?.message });
    }
}

function* createNotice(action) {
    try {
        const result = yield call(req.createNoticeReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_CREATE_NOTICE_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_CREATE_NOTICE_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_CREATE_NOTICE_FAILURE, message: e?.message });
    }
}

function* updateNotice(action) {
    try {
        const result = yield call(req.updateNoticeReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_UPDATE_NOTICE_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_UPDATE_NOTICE_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_UPDATE_NOTICE_FAILURE, message: e?.message });
    }
}

function* deleteNotice(action) {
    try {
        const result = yield call(req.deleteNoticeReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_DELETE_NOTICE_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_DELETE_NOTICE_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_DELETE_NOTICE_FAILURE, message: e?.message });
    }
}

function* publishNotice(action) {
    try {
        const result = yield call(req.publishNoticeReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_PUBLISH_NOTICE_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_PUBLISH_NOTICE_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_PUBLISH_NOTICE_FAILURE, message: e?.message });
    }
}

function* archiveNotice(action) {
    try {
        const result = yield call(req.archiveNoticeReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_ARCHIVE_NOTICE_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_ARCHIVE_NOTICE_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_ARCHIVE_NOTICE_FAILURE, message: e?.message });
    }
}

function* resendNotice(action) {
    try {
        const result = yield call(req.resendNoticeReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_RESEND_NOTICE_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_RESEND_NOTICE_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_RESEND_NOTICE_FAILURE, message: e?.message });
    }
}

function* getNoticeComments(action) {
    try {
        const result = yield call(req.getNoticeCommentsReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_GET_NOTICE_COMMENTS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_NOTICE_COMMENTS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_GET_NOTICE_COMMENTS_FAILURE, message: e?.message });
    }
}

function* addNoticeComment(action) {
    try {
        const result = yield call(req.addNoticeCommentReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_ADD_NOTICE_COMMENT_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_ADD_NOTICE_COMMENT_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_ADD_NOTICE_COMMENT_FAILURE, message: e?.message });
    }
}

function* deleteNoticeComment(action) {
    try {
        const result = yield call(req.deleteNoticeCommentReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_DELETE_NOTICE_COMMENT_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_DELETE_NOTICE_COMMENT_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_DELETE_NOTICE_COMMENT_FAILURE, message: e?.message });
    }
}

function* uploadNoticeAttachments(action) {
    try {
        const result = yield call(req.uploadNoticeAttachmentsReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_UPLOAD_NOTICE_ATTACHMENTS_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_UPLOAD_NOTICE_ATTACHMENTS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_UPLOAD_NOTICE_ATTACHMENTS_FAILURE, message: e?.message });
    }
}

function* deleteNoticeAttachment(action) {
    try {
        const result = yield call(req.deleteNoticeAttachmentReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_DELETE_NOTICE_ATTACHMENT_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_DELETE_NOTICE_ATTACHMENT_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_DELETE_NOTICE_ATTACHMENT_FAILURE, message: e?.message });
    }
}

function* acknowledgeNotice(action) {
    try {
        const result = yield call(req.acknowledgeNoticeReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_ACKNOWLEDGE_NOTICE_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_ACKNOWLEDGE_NOTICE_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_ACKNOWLEDGE_NOTICE_FAILURE, message: e?.message });
    }
}

function* getNoticeAcknowledgements(action) {
    try {
        const result = yield call(req.getNoticeAcknowledgementsReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_GET_NOTICE_ACKNOWLEDGEMENTS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_NOTICE_ACKNOWLEDGEMENTS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_GET_NOTICE_ACKNOWLEDGEMENTS_FAILURE, message: e?.message });
    }
}

function* getNoticeEnums(action) {
    try {
        const result = yield call(req.getNoticeEnumsReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_GET_NOTICE_ENUMS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_NOTICE_ENUMS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_GET_NOTICE_ENUMS_FAILURE, message: e?.message });
    }
}

function* getNoticeAudienceOptions(action) {
    try {
        const result = yield call(req.getNoticeAudienceOptionsReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_GET_NOTICE_AUDIENCE_OPTIONS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_NOTICE_AUDIENCE_OPTIONS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_GET_NOTICE_AUDIENCE_OPTIONS_FAILURE, message: e?.message });
    }
}

function* getNoticeStats(action) {
    try {
        const result = yield call(req.getNoticeStatsReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_GET_NOTICE_STATS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_NOTICE_STATS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_GET_NOTICE_STATS_FAILURE, message: e?.message });
    }
}

export default function* NoticeSaga() {
    yield takeLatest(types.SOCIETY_GET_NOTICES_LIST, getNoticesList);
    yield takeLatest(types.SOCIETY_GET_NOTICE_BOARD, getNoticeBoard);
    yield takeLatest(types.SOCIETY_GET_NOTICE_DETAILS, getNoticeDetails);
    yield takeLatest(types.SOCIETY_CREATE_NOTICE, createNotice);
    yield takeLatest(types.SOCIETY_UPDATE_NOTICE, updateNotice);
    yield takeLatest(types.SOCIETY_DELETE_NOTICE, deleteNotice);
    yield takeLatest(types.SOCIETY_PUBLISH_NOTICE, publishNotice);
    yield takeLatest(types.SOCIETY_ARCHIVE_NOTICE, archiveNotice);
    yield takeLatest(types.SOCIETY_RESEND_NOTICE, resendNotice);
    yield takeLatest(types.SOCIETY_GET_NOTICE_COMMENTS, getNoticeComments);
    yield takeLatest(types.SOCIETY_ADD_NOTICE_COMMENT, addNoticeComment);
    yield takeLatest(types.SOCIETY_DELETE_NOTICE_COMMENT, deleteNoticeComment);
    yield takeLatest(types.SOCIETY_UPLOAD_NOTICE_ATTACHMENTS, uploadNoticeAttachments);
    yield takeLatest(types.SOCIETY_DELETE_NOTICE_ATTACHMENT, deleteNoticeAttachment);
    yield takeLatest(types.SOCIETY_ACKNOWLEDGE_NOTICE, acknowledgeNotice);
    yield takeLatest(types.SOCIETY_GET_NOTICE_ACKNOWLEDGEMENTS, getNoticeAcknowledgements);
    yield takeLatest(types.SOCIETY_GET_NOTICE_ENUMS, getNoticeEnums);
    yield takeLatest(types.SOCIETY_GET_NOTICE_STATS, getNoticeStats);
    yield takeLatest(types.SOCIETY_GET_NOTICE_AUDIENCE_OPTIONS, getNoticeAudienceOptions);
}
